import { render, staticRenderFns } from "./BlClientsDetail.vue?vue&type=template&id=37ede506&"
import script from "./BlClientsDetail.vue?vue&type=script&lang=js&"
export * from "./BlClientsDetail.vue?vue&type=script&lang=js&"
import style0 from "./BlClientsDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports